export default __webpack_public_path__ + "images/kellyPartnersLogoBlue.v-e9261b098edc0238941c580c7ceb3b97.svg";